<template>
  <div>
    <!--:class="getShape(section.style)"-->
    <section
      :id="`section_pk_${index}`"
      :style="getSectionStyleObject(section, index)"
      v-for="(section, index) in sectionsStore"
      :key="section.id + '_' + index"
      :class="getShape(section.style)"
    >
      <section-layout :type="section.type">
        <slot name="contentTypePreview">
          <component
            v-if="section.showTitle"
            is="section-title"
            :style="getTiTleStyle(section)"
            slot="title"
          >
            <span>{{ section.title }}</span>
          </component>
        </slot>
        <component
          v-if="section.showTitle"
          :is="getDescriptionHeader(section.titleHeader)"
          slot="description"
          class="base-body text--darken-1 pb-lg-12 pb-sm-8"
          :class="section.titleAlign === 'center' ? 'mx-auto' : ''"
          :style="getSubtitleStyle(section)"
        >
          {{ section.description }}
        </component>

        <template slot="body">

          <slot name="block">

            <block
              :theme="theme"
              :sectionId="section.id"
              :sectionTitleColor="section.titleColor"
              :sectionBackgroundColor="section.backgroundColor"
              :sectionBlockLayout="section.settings.blockLayout"
              :sectionZone="section.zone"
              :data="section.blocks"
              :options="options"
            />

          </slot>

        </template>

      </section-layout>
      <div :class="getShapeExtra(section.style)"></div>
    </section>
  </div>
</template>
<script>
  import * as SectionsConfig from '@fremcast/section/config';
  import * as blocks from '@fremcast/section/blocks';
  import styles from "@fremcast/section/mixins/styles";
  const VIDEO_TYPE = 'Videos';
  const PRESENTATION = "videoPresentation";
  export default {
    data() {
      return {
        component: this.theme,
        sections: [],
        displaySectionTitle: true,
        //sectionHeader: SectionsConfig.default[this.theme].headers,
        block: blocks.default.data
      };
    },
    mixins: [
      styles
    ],
    computed: {
      sectionsStore() {
        return this.options.length > 0 ? this.options : this.$store.getters['section/section'].body;
      },
      isRenderedFromLandingPage() {
        return this.options.length === 0
      }
    },
    props: {
      theme: String,
      containsHeaderBlocks: Boolean,
      options: {
        type: Array,
        default() {
          return [];
        }
      },
      slug: {
        type: String,
        default: ''
      }
    },
    components: {
      Block: () => import('./DinamicBlockLoader')
    },
    methods: {
      //Make sure that the layout loaded satisfy the zone.
      //@todo: Fix integer vaue to string via Enums
      getLayout(zone) {
        return zone == 1 ? 'section-header' : 'section-layout'
      },
      getDescriptionHeader(header) {
        return 'p'
        //return 'h' + (parseInt(header.substr(header.length - 1)) + 1)
      },
      componentLoader(load) {
        return require(`@fremcast/section/${load}`).default;
      },
      getPresentationComponentName(section) {
        const presentation = section.settings.presentation || 'list';
        return this.block[section.type].presentation[presentation];
      },
      getSectionKey(section) {
        return _.has(section.settings, PRESENTATION)
          ? section.settings.videoPresentation
          : section.id;
      },
      getNextSection(position) {

        if (position < (this.sectionsStore.length - 1)) {
          return this.sectionsStore[position + 1]
        }

        return this.sectionsStore[position]
      },
      getSectionStyleObject(section, position) {
        let attributes;
        //Add extra margin when no header is set.
        let marginTopExtraSpace = 1;

        if (!this.containsHeaderBlocks && position === 0 && this.isRenderedFromLandingPage) {
          marginTopExtraSpace = 4
        }

        /*
        attributes = {
          '--section-pt': (section.style.marginTop * marginTopExtraSpace) + 'px',
          '--section-pb': section.style.marginBottom + 'px'
        };
        */

        attributes = {
          'padding-top': (section.style.marginTop * marginTopExtraSpace) + 'px',
          'padding-bottom': section.style.marginBottom + 'px',
          '--section-bg': this.getGradientImage(section).background,
          '--section-bg-image': this.getGradientImage(section).backgroundImage,
          '--section-next-bg': this.getGradientImage(this.getNextSection(position)).background,
          '--section-next-bg-image': this.getGradientImage(this.getNextSection(position)).backgroundImage,
          ...this.getBackgroundColor(section)
        };

        return attributes;
      },
      getTiTleStyle(section) {
        return {
          'flex-direction': 'column',
          'color': section.titleColor,
          //'justify-content': section.titleAlign,
          'text-align': section.titleAlign + ' !important',
          'margin-bottom': 30 + 'px'
        };
      },
      getSubtitleStyle(section) {
        let styles = {
          'max-width': 700 + 'px',
          'font-size': 18 + 'px'
        }

        return {
          ...this.getTiTleStyle(section),
          ...styles
        }
      },
      getShape(style) {
        let shapeClass;
        switch(style.noneRectangularShapeName) {
          case 'diagonal':
            shapeClass = 'section_none_rectangular';
            break;
          case 'curved':
            shapeClass = 'section_curve_background';
            break;
          case 'wave':
            shapeClass = 'wave_container';
            break;
          case 'spikes':
            shapeClass = 'spikes';
            break;
          default:
            shapeClass = 'section_rectangular';
        }

        return shapeClass;
      },
      getShapeExtra(style) {
        let shapeClass;
        switch(style.noneRectangularShapeName) {
          case 'diagonal':
            shapeClass = '';
            break;
          case 'curved':
            shapeClass = '';
            break;
          case 'wave':
            shapeClass = 'wave';
            break;
          case 'spikes':
            shapeClass = '';
            break;
          default:
            shapeClass = '';
        }

        return shapeClass;
      }
    }
  }
</script>
<style scoped>

  section_var {
    padding-top: var(--section-pt);
    padding-bottom: var(--section-pb);
    background-color: var(--section-bg);
  }

  .section-description {
    font-weight: 100;
  }

  .section_none_rectangular {
    position: relative;
    width: 100%;
    height: auto;
    display:flex;
    justify-content: center;
    align-items: center;
  }

  .section_none_rectangular:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    /*background: #fff;*/
    background: var(--section-next-bg);
    background-image: var(--section-next-bg-image);
    clip-path: polygon(100% 50%,0 100%, 100% 100%);
    -webkit-clip-path: polygon(100% 50%,0 100%, 100% 100%);
  }

  .section_curve_background {
    /* Background color */
    /*background-color: rgba(0, 0, 0, 0.3);*/
    background-color: var(--section-bg);
    /* You can use gradient background color such as
    background: linear-gradient(rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.1) 100%); */

    position: relative;
    border-bottom-left-radius: 50% 20%;
    border-bottom-right-radius: 50% 20%;

  }

  .wave_container {
    position: relative;
    background: var(--section-bg);
  }

  .wave {
    position: absolute;
    height: 121px;
    width: 100%;
    background: var(--section-bg);
    background-image: var(--section-bg-image);
    bottom: 0;
  }

  .wave::before, .wave::after {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100% 50%;
  }

  .wave::before {
    width: 55%;
    height: 109%;
    background-color: var(--section-next-bg);
    background-image: var(--section-next-bg-image);
    right: -1.5%;
    top: 60%;
  }
  .wave::after {
    width: 55%;
    height: 100%;
    left: -1.5%;
    top: 40%;
  }

  .spikes {
    position: relative;
    background-color: var(--section-bg);
    /*height: 50vh;*/
  }

  .spikes::after {
    content: '';
    position: absolute;
    background-repeat: repeat;
    right: 0;
    left: -0%;
    top: 100%;
    z-index: 10;
    display: block;
    height: 50px;
    background-size: 50px 100%;
    background-image: linear-gradient(135deg, var(--section-bg) 25%, transparent 25%), linear-gradient(225deg, var(--section-bg) 25%, transparent 25%);
    background-position: 0 0;
  }

  .triangle {
    position: relative;
    background: #2c3e50;
    /*height: 50vh;*/
  }

  .triangle::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 100px 100px 0 100px;
    border-color: #2c3e50 transparent transparent transparent;
    left: 50%;
    transform: translateX(-50%) translateY(100%);
  }

</style>
